<div class="container">
  <div class="row py-5">
    <div class="offset-sm-1 offset-md-2 offset-xl-4 col-sm-10 col-md-8 col-xl-4 py-5">
      <div class="contformLogin">
        <h2>STIHL LOCAL PLUS - PORTUGAL</h2>
        <h3>Bem-vindo</h3>
        <form [formGroup]="loginform" (ngSubmit)="login()">
          <div class="form-group mb-3">
            <input placeholder="Utilizador" formControlName="username" class="form-control" />
            <label class="error" *ngIf="loginform.get('username').errors?.['required']">*Este campo es obligatorio.</label>
          </div>
          <div class="form-group mb-3">
            <input placeholder="Contraseña" formControlName="password" type="password" class="form-control" />
            <label class="error" *ngIf="loginform.get('password').errors?.['required']">*Este campo es obligatorio.</label>
          </div>
          <input type="submit" class="btn-orange" value="Entrar">
        </form>
      </div>
    </div>
  </div>
</div>